import config from './config';
import constants from './constants';

// Unknown or missing appType falls back to the default experience.
export function isPatientAppType(appType) {
  return appType === constants.PATIENT_APP_TYPE;
}

export function isPatientPortalWebClient(clientId) {
  return !!clientId && config.patientPortalWebClientIds.includes(clientId);
}

export function isPatientMobileClient(clientId) {
  return !!clientId && config.patientMobileClientIds.includes(clientId);
}
